stimulusApp.register(
  "new-pin",
  class extends Stimulus.Controller {
    static targets = ["timer", "timerContainer", "link"]
    static values = {
      timeout: Number,
    }

    #timer = null

    connect() {
      const rtf = new Intl.RelativeTimeFormat(window.locale, { style: "short" })

      if (this.timeoutValue !== 0) {
        this.#timer = setInterval(() => {
          this.timeoutValue--

          let parts = rtf.formatToParts(this.timeoutValue, "seconds")
          this.timerTarget.innerText = parts.at(-2).value + parts.at(-1).value

          if (!this.timeoutValue) {
            clearInterval(this.#timer)
            this.timerContainerTarget.remove()
            this.linkTarget.classList.remove("hidden")
          }
        }, 1000)
      }
    }

    submit() {
      this.element.requestSubmit()
    }
  },
)
